// extracted by mini-css-extract-plugin
export default {"printWrapper":"styles_printWrapper__joJOg","printIcon":"styles_printIcon__Lwu1Y"};